import './georgetown1/style';
import FormStructure from './georgetown1/form_structure';

export default FormStructure;